import PropTypes from "prop-types";
import React from "react";

/**
 * MinuteRender is a utility component that renders its children
 * at every minute. It polls the every second to confirm if the
 * current minute has changed before re-rendering.
 */
class MinuteRender extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.node.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = { minute: new Date().getMinutes() };
  }

  componentDidMount() {
    this.clockTimer = window.setInterval(() => {
      const { minute: lastMinute } = this.state;
      const minute = new Date().getMinutes();

      if (lastMinute !== minute) {
        this.setState({ minute });
      }
    }, 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.clockTimer);
  }

  render() {
    const { children } = this.props;

    return React.cloneElement(children);
  }
}

export { MinuteRender };
